<template>
    <div>
        <vx-card v-if="projectsCount > 1">
            <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full">
                    <p class="text-center"><strong>Tablas de amortización</strong></p>
                    <div class="flex justify-center flex-wrap small-flex">
                        <vs-button color="#303f9f" type="line" class="mr-1" icon-pack="feather" icon="icon-list" @click="popupGlobalMasterActive = true">Consolidada</vs-button>
                        <vs-button color="#303f9f" type="line" icon-pack="feather" icon="icon-box" @click="popupProjectMasterActive = true">Por proyecto</vs-button>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                    <p class="text-center"><strong>Adeudos</strong></p>
                    <div class="flex justify-center flex-wrap small-flex">
                        <vs-button color="danger" type="line" class="mr-1" icon-pack="feather" icon="icon-user" @click="popupGlobalDueActive=true">Del solicitante</vs-button>
                        <vs-button color="danger" type="line" icon-pack="feather" icon="icon-box" @click="popupDueProjectActive=true">Por proyecto</vs-button>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                    <p class="text-center"><strong>Otras opciones</strong></p>
                    <div class="flex justify-center flex-wrap small-flex">
                        <vs-button color="primary" type="line" icon-pack="feather" icon="icon-dollar-sign" @click="popupTransactionsActive=true">Transacciones</vs-button>
                        <vs-button color="primary" type="line" class="ml-1 mr-1"  icon-pack="feather" icon="icon-plus" @click="popupFundCapitalActive=true">Abono a capital</vs-button>
                        <!-- <vs-button color="primary" type="line" icon-pack="feather" icon="icon-briefcase" @click="popupNegotiationsActive=true">Negociaciones</vs-button> -->
                    </div>
                </div>
            </div>
        </vx-card>
        <vx-card v-else>
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div class="flex justify-center flex-wrap small-flex">
                        <vs-button color="#303f9f" type="line" class="mr-5" icon-pack="feather" icon="icon-list" @click="popupProjectMasterActive = true">Tabla de amortización</vs-button>
                        <vs-button color="danger" type="line" class="mr-5" icon-pack="feather" icon="icon-user" @click="popupGlobalDueActive=true">Adeudos</vs-button>
                        <vs-button color="primary" type="line" class="mr-5" icon-pack="feather" icon="icon-dollar-sign" @click="popupTransactionsActive=true">Transacciones</vs-button>
                        <vs-button color="primary" type="line" class="mr-5" icon-pack="feather" icon="icon-plus" @click="popupFundCapitalActive=true">Abono a capital</vs-button>
                        <!-- <vs-button color="primary" type="line" icon-pack="feather" icon="icon-briefcase" @click="popupNegotiationsActive=true">Negociaciones</vs-button>                     -->
                    </div>
                </div>
            </div>
        </vx-card>

        <!-- VENTANAS FLOTANTES -->
        <vs-popup fullscreen class="header-primary" title="Tabla de amortización (consolidada)" :active.sync="popupGlobalMasterActive">
            <vx-card>
                <div class="vx-row">
                    <div class="vx-col w-full lg:w-full">
                        <master-amortization v-if="popupGlobalMasterActive" :project_id="project_id" ref="project_master" @updated="update"></master-amortization>
                    </div>
                </div>
            </vx-card>
        </vs-popup>
        <vs-popup fullscreen class="header-primary" title="Tablas de amortización (por proyecto)" :active.sync="popupProjectMasterActive">
            <vx-card>
                <div class="vx-row">
                    <div class="vx-col w-full lg:w-full">
                        <master-amortization-projects v-if="popupProjectMasterActive" :project_id="project_id" ref="project_master_projects" @updated="update"></master-amortization-projects>
                    </div>
                </div>
            </vx-card>
        </vs-popup>
        <vs-popup fullscreen class="header-primary" title="Adeudos del solicitante" :active.sync="popupGlobalDueActive">
            <vx-card>
                <div class="vx-row">
                    <div class="vx-col w-full lg:w-full">
                        <dues v-if="popupGlobalDueActive" :project_id="project_id" ref="project_dues" @updated="update"></dues>
                    </div>
                </div>
            </vx-card>
        </vs-popup>
        <vs-popup fullscreen class="header-primary" title="Adeudos por proyecto" :active.sync="popupDueProjectActive">
            <vx-card>
                <div class="vx-row">
                    <div class="vx-col w-full lg:w-full">
                        <dues-project v-if="popupDueProjectActive" :project_id="project_id" ref="project_dues_grouped" @updated="update"></dues-project>
                    </div>
                </div>
            </vx-card>
        </vs-popup>
        <vs-popup fullscreen class="header-primary" title="Transacciones del solicitante" :active.sync="popupTransactionsActive">
            <vx-card>
                <div class="vx-row">
                    <div class="vx-col w-full lg:w-full">
                        <div class="flex flex-wrap">
                            <vs-icon icon="info" size="small" color="red"></vs-icon>
                            <label class="mt-1 ml-2">Si existen dispersiones en proceso es probable que no se muestre la información completa.</label>
                        </div>
                        <vs-tabs v-model="optionActiveTab" color="success" alignment="fixed" class="tab-action-btn-fill-container mt-5">
                            <vs-tab key="payments" label="Pagos">
                                <div class="tab-text">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <vx-card>
                                                <transactions v-if="popupTransactionsActive" :project_id="project_id" ref="project_transactions"></transactions>
                                            </vx-card>
                                        </div>
                                    </div>
                                </div>
                            </vs-tab>
                            <vs-tab key="movements" label="Movimientos">
                                <div class="tab-text">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <applicant-movements v-if="popupTransactionsActive" :project_id="project_id" ref="applicant_movements"  @updated="update"></applicant-movements>
                                        </div>
                                    </div>
                                </div>
                            </vs-tab>
                            <vs-tab key="deposits" label="Abonos">
                                <div class="tab-text">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <applicant-deposits v-if="popupTransactionsActive" :project_id="project_id" ref="applicant_deposits"  @updated="update"></applicant-deposits>
                                        </div>
                                    </div>
                                </div>
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </div>
            </vx-card>
        </vs-popup>
        <vs-popup fullscreen class="header-primary" title="Abono a capital" :active.sync="popupFundCapitalActive">
            <vx-card>
                <div class="vx-row">
                    <div class="vx-col w-full lg:w-full">
                        <!-- <vs-tabs v-if="projectsCount > 1" color="success" alignment="fixed" class="tab-action-btn-fill-container">
                            <vs-tab label="Consolidado">
                                <div class="tab-text">
                                    <fund-capital :project_id="project_id" ref="fund_capital"  @updated="update"></fund-capital>
                                </div>
                            </vs-tab>
                            <vs-tab :label="'PID actual: '+project_id">
                                <div class="tab-text">
                                    <fund-capital-project :project_id="project_id" ref="fund_capital_project"  @updated="update"></fund-capital-project>
                                </div>
                            </vs-tab>
                        </vs-tabs>
                        <fund-capital v-else :project_id="project_id" ref="fund_capital"  @updated="update"></fund-capital> -->

                        <vs-tabs  color="success" alignment="fixed" class="tab-action-btn-fill-container">
                            <vs-tab :label="'PID actual: '+project_id">
                                <div class="tab-text">
                                    <fund-capital-project v-if="popupFundCapitalActive" :project_id="project_id" ref="fund_capital_project"  @updated="update"></fund-capital-project>
                                </div>
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </div>
            </vx-card>
        </vs-popup>
        <vs-popup  class="header-primary extended-popup" title="Negociaciones" :active.sync="popupNegotiationsActive">
            <vx-card>
                <div class="vx-row">
                    <div class="vx-col w-full lg:w-full">
                        <negotiations v-if="popupNegotiationsActive" :project_id="project_id" ref="negotiations"  @updated="update"></negotiations>
                    </div>
                </div>
            </vx-card>
        </vs-popup>
        <!-- VENTANAS FLOTANTES -->
    </div>
</template>

<script>
    let master_amortization = require("./MasterAmortization").default;
    const master_amortization_projects = require("./MasterAmortizationProjects").default;
    let dues = require("./Dues").default;
    let dues_project = require("./DuesProject").default;
    let transactions = require("./Transactions").default;
    let fund_capital = require("./FundCapital").default;
    let fund_capital_project = require("./FundCapitalProject").default;
    let negotiations = require("./Negotiations").default;
    const applicant_movements = require("./ApplicantMovements").default;
    const applicant_deposits = require("./ApplicantDeposits").default;

    export default {
        name: "Payments",
        props:['project_id'],
        components:{
            'master-amortization': master_amortization,
            'master-amortization-projects': master_amortization_projects,
            'dues': dues,
            'transactions': transactions,
            'fund-capital': fund_capital,
            'fund-capital-project': fund_capital_project,
            'negotiations': negotiations,
            'dues-project': dues_project,
            'applicant-movements': applicant_movements,
            'applicant-deposits': applicant_deposits
        },
        data(){
            return {
                projectsCount: 0,
                optionActiveTab:0,
                popupGlobalMasterActive:false,
                popupProjectMasterActive:false,
                popupGlobalDueActive:false,
                popupDueProjectActive:false,
                popupTransactionsActive:false,
                popupFundCapitalActive:false,
                popupNegotiationsActive:false
            }
        },
        async mounted(){
            await this.getProjectsCount();
        },
        methods:{
            update(){
                this.$emit('updated', 1)
            },
            reset(){
                // this.$refs.project_master.getMaster()
                // this.$refs.project_master_projects.getMaster()
                // this.$refs.project_dues.getInformation()
                // this.$refs.project_dues_grouped.getInformation()
                // this.$refs.project_transactions.getInformation()
                // this.$refs.negotiations.getNegotiation()
                // this.$refs.fund_capital.simularLiquidacion()
            },
            async getProjectsCount(){
                await axios.get('/api/cobranza/proyectosCliente/' + this.project_id).then(response => {
                    this.projectsCount = response.data;
                }).catch(error => {
                    Vue.toasted.clear();
                    Vue.toasted.show('Ha ocurrido un error intente mas tarde.', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 2000});
                });
            },
        }
    }
</script>

<style scoped>
    .modal-dialog{
        min-width: 90%;
    }
</style>
